import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './ErrorHandling/ErrorHandling';
import RouterErrorBoundary from './components/ui/RouterErrorBoundary';
import App from './App';



// Import styles
import './styles/index.css';
// import reportWebVitals from './reportWebVitals';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { suppressConsole } from "no-console-production";

//30/04/26
// Capture traffic source for New Relic (only set on initial page load)
declare global {
  interface Window {
    newrelic?: {
      setCustomAttribute: (name: string, value: string | number) => void;
    };
  }
}
if (window.newrelic) {
  window.newrelic.setCustomAttribute('trafficSource', document.referrer || 'direct');
}
//end of 30/04/26 addition

// Only suppress in production unless REACT_APP_SHOW_CONSOLE is true
const showConsole =
  process.env.NODE_ENV === 'development' ||
  window.location.search.includes('version=dev');

if (
  process.env.NODE_ENV === "production" &&
  !showConsole
) {
  suppressConsole();
}

console.log('React at entry:', React);

// For debugging - ensure devtools are visible
const urlParams = new URLSearchParams(window.location.search);
let displayMode = process.env.NODE_ENV as string; // actual build mode
if (urlParams.get('version') === 'dev') {
  displayMode = 'development';
} else if (urlParams.get('version') === 'beta') {
  displayMode = 'beta';
}
if (showConsole) {
  console.log('MODE:', displayMode);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Create QueryClient with devtools-friendly configuration
const qClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (was cacheTime)
    },
  },
});


root.render(
  <React.StrictMode>
    <QueryClientProvider client={qClient}>
      <ErrorBoundary>
        <RouterErrorBoundary>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </RouterErrorBoundary>
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
// serviceWorkerRegistration.register();